import { object, string } from "yup";

export const loginSchema = object().shape({
  mobileNumber: string()
  .required("Login.phoneNumber")
    // .matches(/^[6-9]\d{9}$/, {
    //   message: "Login.mobileRequired",
    //   excludeEmptyString: false,
    // })
    .matches(/^[6-9]\d{9}$|^0\d{10}$/, {
      message: "Login.mobileRequired",
      excludeEmptyString: false,
    })
    
    ,
});
export const initialLoginState = {
  mobileNumber: "",
};
